<template>
  <div class="content-wrapper">
    <banner
      :slideUrls="slideUrls"
      :channel_id='params.nav_id'
    ></banner>
    <Download v-if="downLoadShow" />
    <div
      class="blocks-wrap max-page"
      :class="blocksTop ? 'blocks-top': ''"
    >
      <common-block
        :channel_id='params.nav_id'
        :blockInfo="blockInfo"
      ></common-block>
    </div>
    <div class="_fz811ps7qhv" style="position:fixed; bottom: 10px; right: 10px; display: none" ref="adFloatAd"></div>
  </div>
</template>
<script>
import Download from './components/Download'
import Banner from './components/Banner'
import CommonBlock from '@/components/CommonBlock'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('HomePage')

export default {
  name: 'HomePage',
  components: {
    CommonBlock,
    Banner,
    Download
  },
  data () {
    return {
      params: {
        nav_id: '203',
        pg: 1
      },
      channel_id: '',
      slideUrls: {},
      blockInfo: [],
      pageInfo: {},
      downLoadShow: false
    }
  },
  computed: {
    blocksTop () {
      if (Object.keys(this.slideUrls).length > 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    $route (val) {
      console.log('home route', val)
      // this.params.nav_id = val.params.id;
      this.getInfo()
    }
  },
  methods: {
    ...mapActions(['get_channelhome']),
    async getInfo () {
      let self = this
      self.params['cp'] = 'fr4k0se'
      self.params['cl'] = self.$store.state.common.cl
      self.params['nav_id'] = self.$route.params.id || '203'
      self.blockInfo = []
      self.slideUrls = {}
      this.downLoadShow = false
      self.pageInfo = await self.get_channelhome(self.params)
      for (let i = 0; i < self.pageInfo.blocks.length; i++) {
        if (self.pageInfo.blocks[i].template === 'focus') {
          self.slideUrls = self.pageInfo.blocks[i]
        }
        if (self.pageInfo.blocks[i].template === 'poster' || self.pageInfo.blocks[i].template === 'still') {
          self.blockInfo.push(self.pageInfo.blocks[i])
        }
      }
      this.downLoadShow = true
    },
    initAdvert () {
      let advertsArray = [
        {
          id: 'u6731989',
          container: '_um32i2mvbkt'
        },
        {
          id: 'u6731885',
          container: '_fz811ps7qhv'
        }
      ]
      setTimeout(() => {
        advertsArray.map(item => {
          (window.slotbydup = window.slotbydup || []).push({
            id: item.id,
            container: item.container,
            async: true,
            noAd: function (tu_index) {
              let before_index = tu_index.split('_')[0]
              if (item.id == before_index) {
                let before_container = item.container
                document.getElementsByClassName(before_container).style.display = 'none'
              }
            }
          })
        })
        let ad_script = document.createElement('script')
        ad_script.type = 'text/javascript'
        ad_script.src = '//cpro.baidustatic.com/cpro/ui/cm.js'
        let ad_body = document.getElementsByTagName('body')[0]
        ad_body.appendChild(ad_script)
      }, 500)
    },
    handleScroll () {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      const downlaod = document.getElementsByClassName('download-banner')[0].offsetTop
      if (scrollTop > downlaod) {
        this.$refs.adFloatAd.style.display = 'block'
      } else {
        this.$refs.adFloatAd.style.display = 'none'
      }
    },
    test () {
      this.flag = false
    }
  },
  mounted () {
    // 此时的dom 都已经生成
    this.getInfo().then(() => {
      // 监听 滚动条
      // window.addEventListener('scroll', this.handleScroll, true)
      // this.initAdvert()
    })
  }
}
</script>
<style lang='less' scoped>
.content-wrapper {
  background: #16161c;
  min-height: 900px;
  .blocks-top {
    margin-top: 30px;
  }
  .jumpDownload {
    position: relative;
    font-size: 16px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    color: #ffffff;
    background-color: #1f1f1f;
    border-radius: 4px;
    padding: 0px 12% 5px 10%;
    .mark {
      font-size: 25px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #fff;
      margin-bottom: 10px;
      span {
        margin: 15px 300px 0 170px;
        display: inline-block;
        vertical-align: top;
      }
    }
    img {
      height: 200px;
      margin-left: 137px;
    }

    .test-sign {
      float: right;
      text-align: right;
      margin-top: -5px;
      position: relative;
      .text {
        margin-bottom: 45px;
        h3.mark {
          margin-bottom: 20px;
        }
        h4 {
          margin-bottom: 20px;
        }
      }
      .btn {
        float: right;
        width: 113.3px;
        padding: 8px 15px;
        background: #1a9eff;
        border-radius: 17px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        img {
          height: 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homePage/index.vue